import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import T from '../../../app/Locale';
const LifescoreBar = ({ path, lifeScore }) => {
    const [showTooltip, toggleTooltip] = useState(false);
    const clickIcon = (event) => {
        event.preventDefault();
        toggleTooltip(!showTooltip);
    };
    return (_jsxs("div", Object.assign({ className: 'toolbar-score--wrapper' }, { children: [_jsxs("a", Object.assign({ href: path, className: 'toolbar-score' }, { children: [_jsx("i", { className: 'far fa-question-circle toolbar-help', title: T.translate('lifescore.tooltip'), onClick: clickIcon, role: 'button', tabIndex: 0, "aria-label": 'Save' }), T.translate('lifescore.menu', { score: lifeScore }), _jsx("div", { className: 'toolbar-progress', style: { width: `${lifeScore}%` } })] })), _jsxs("div", Object.assign({ className: `toolbar-dropdown-lifescore toolbar-dropdown ${showTooltip ? 'toolbar-dropdown--open' : ''}` }, { children: [T.translate('lifescore.description'), _jsx("br", {}), _jsx("br", {}), _jsx("button", Object.assign({ className: 'button green', onClick: () => toggleTooltip(false) }, { children: "OK" }))] }))] })));
};
LifescoreBar.propTypes = {
    path: PropTypes.string.isRequired,
    lifeScore: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string
    ]).isRequired
};
export default LifescoreBar;
